import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsWidgetConfigurationCustomizeRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsWidgetConfigurationCustomizeRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint } from './ui/widget-configuration/customize-entry.tsx';
import { navigation } from './common/constants.tsx';

export const helpCenterSettingsWidgetConfigurationCustomizeRouteEntry = createEntry(
	helpCenterSettingsWidgetConfigurationCustomizeRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.widget-configuration.customize',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint: () => {
			if (!fg('csm_agent_config_widget_configuration_embed_page')) {
				return undefined;
			}
			return HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint;
		},

		resources: [...getServiceDeskSettingsResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsWidgetConfigurationCustomizeRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsWidgetConfigurationCustomizeRouteEntry',
			},

			enabled: true,
		},
	}),
);
